import React, { useState } from "react";
import styled from "styled-components";
import MainMenu from "../Components/Main_Menu";
import StoryFeed from "../Components/StoryFeed";
import RecommendFriend from "../Components/RecommendFriend";
import Feed from "../Components/Feed";
import Search from "./Search";

const Home = () => {
  return (
    <>
      <HomeWrap>
        <MainMenu />
        <Search />
        <HomeContentWrap>
          <FeedWrap>
            <StoryFeed />
            <Feed />
          </FeedWrap>
          <RecommendFriend />
        </HomeContentWrap>
      </HomeWrap>
    </>
  );
};

export default Home;

const HomeWrap = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const HomeContentWrap = styled.div`
  width: calc(100% - 240px);
  position: relative;
  left: 240px;

  display: flex;

  @media (max-width: 1264px) {
    width: calc(100% - 80px);
    left: 90px;
  }
  @media (max-width: 767px) {
    width: 100%;
    left: 0;
  }
`;

const FeedWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #efefef;

  @media (max-width: 767px) {
    margin-top: 70px;
  }
`;
